import * as React from 'react';

export const MinimizeIcon: React.SFC<{}> = () => (
    <svg width="14px" height="2px" viewBox="0 0 14 2" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polygon points="0 0 0 2 14 2 14 0" fill="#424242"/>
        </g>
    </svg>
);
